export const collection = 'muscle';
export const muscleCategoryCollection = 'cms_category_muscle';
export const carcasePath = 'carcase';
export const photoRefPath = 'photo_ref';
export const modelPath = 'model3d';
